import { Button, Dialog, Paper } from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

import MyTypography from "../MyTypography";

interface DialogInfoProps {
  onClose: () => void;
  isOpen: boolean;
  contentText: string;
  buttonText: string;
}

const useStyles = makeStyles(
  {
    root: {
      padding: "3rem 3rem",
      backgroundColor: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    desc: {
      color: "#333",
      marginBottom: "2rem",
      whiteSpace: "pre-wrap",
      textAlign: "center"
    },
    closeBtn: {
      fontSize: "16px",
      display: "block",
      margin: "0 auto",
      padding: "1rem 7rem",
      color: "white",
      backgroundColor: "#E24322",
      border: "1px solid #E24322",
      "&:hover": {
        color: "#E24322",
        backgroundColor: "white",
        border: "1px solid #E24322"
      }
    }
  },
  { name: "DialogInfo" }
);

const DialogInfo: React.FC<DialogInfoProps> = props => {
  const classes = useStyles();

  return (
    <Dialog open={props.isOpen} onClose={props.onClose}>
      <Paper className={classes.root}>
        <MyTypography variant="body2" className={classes.desc}>
          {props.contentText}
        </MyTypography>
        <Button onClick={props.onClose} className={classes.closeBtn}>
          {props.buttonText}
        </Button>
      </Paper>
    </Dialog>
  );
};

export default DialogInfo;
